import { render, staticRenderFns } from "./EditAttachmentTypesPage.vue?vue&type=template&id=efaa527a&"
import script from "./EditAttachmentTypesPage.vue?vue&type=script&lang=js&"
export * from "./EditAttachmentTypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports